import type { ReactNode } from 'react'
import React, { useMemo, useState } from 'react'
import type { DiscountInfo } from './DiscountContext'
import DiscountContext from './DiscountContext'

type Props = {
  children: ReactNode
}

export const DiscountProviderComponent = ({ children }: Props) => {
  const [discountInfo, setDiscountInfo] = useState<DiscountInfo | null>(null)
  const value = useMemo(() => {
    return { discountInfo, setDiscountInfo }
  }, [discountInfo])
  return (
    <DiscountContext.Provider value={value}>
      {children}
    </DiscountContext.Provider>
  )
}
